import { UtilityService } from '../utility.service';

/**
 * This class handles background activity on modal.
 */
export class BgOverlayService {
	private utilityService: UtilityService;
	private componentMapping = {
		centralBanner: 0,
		Banner: 1,
		cornerModal: 2,
		centralModal: 3,
		infoModal: 4,
		iFrameModal: 5
	};
	/**
	 * @param utilityService: The UtilityService 
	 */
	constructor(utilityService: UtilityService) {
		this.utilityService = utilityService;
	}

	/**
	 * Returns an object containing the information about the background
	 * of different components. If no settings are found, a default object is returned
	 */
	getOverlayProperty(component: string) {
		const output = {
			darken: 0,
			overlayBackground: false,
			clickToClose: false
		};
		if (this.utilityService) {
			const bg = this.utilityService.settingsService.settings.backgroundOverlay;
			if (bg instanceof Array) {
				bg.forEach((element, index) => {
					if (
						element.target.indexOf(this.componentMapping[component]) !== -1
					) {
						output.darken =
							element.darken && element.darken < 101
								? element.darken / 100
								: 0;
						output.overlayBackground = output.darken ? true : false;
						output.clickToClose = element.clickToClose;
						return output;
					}
				});
			}
		}
		return output;
	}
}
